import {
  afterRenderEffect,
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  input,
  model,
  output,
  signal,
  viewChild,
} from '@angular/core';
import {
  DayLabelPipe,
  ImmomioIconName,
  ITicketMessageGroup,
  TicketStatus,
} from '@resident-nx/shared';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { TicketDetailsChatLoaderComponent } from './ticket-details-chat-loader/ticket-details-chat-loader.component';
import { IconWebComponent } from '@resident-nx/web/ui';
import { ImmomioCircleButtonComponent } from '@immomio/ui/button';

@Component({
  selector: 'rs-web-ticket-details-chat',
  templateUrl: './ticket-details-chat.component.html',
  styleUrl: './ticket-details-chat.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslatePipe,
    FormsModule,
    ImmomioCircleButtonComponent,
    IconWebComponent,
    TicketDetailsChatLoaderComponent,
    DatePipe,
    DayLabelPipe,
  ],
})
export class TicketDetailsChatComponent {
  protected readonly icons = ImmomioIconName;
  protected readonly ticketStatus = TicketStatus;
  isReadOnly = input(false);
  loading = input(false);
  sending = input(false);
  ticketState = input<TicketStatus>(undefined);
  sendMessage = output<string>();
  retryMessage = output<string>();
  refreshChat = output();
  chatContainer = viewChild<ElementRef<HTMLDivElement>>('chatContainer');
  ticketChat = input<ITicketMessageGroup[]>([]);

  readonly getTicketChatPlaceholder = computed(() => {
    if (
      this.ticketState() === this.ticketStatus.CANCELLED ||
      this.ticketState() === this.ticketStatus.CLOSED
    ) {
      return 'ticket_chat.ticket_closed_placeholder_l';
    } else if (this.isReadOnly()) {
      return 'ticket_chat.read_only_state_l';
    } else {
      return 'ticket_chat.new_message_placeholder_l';
    }
  });

  public message = model('');
  public showUpdateBanner = signal(true);

  constructor() {
    afterRenderEffect(() => {
      this.ticketChat();
      const el = this.chatContainer()?.nativeElement;
      el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
    });
  }

  public onSendMessage(): void {
    if (
      this.ticketState() !== TicketStatus.CLOSED &&
      this.ticketState() !== TicketStatus.CANCELLED &&
      !this.sending()
    ) {
      this.sendMessage.emit(this.message().trim());
      this.message.set('');
    }
  }

  public onRetryMessage(messageId: string) {
    this.retryMessage.emit(messageId);
  }
}
